import Avatar6 from '../../../assets/images//xs/avatar6.svg';
import Avatar1 from '../../../assets/images//xs/avatar1.svg';
import Avatar4 from '../../../assets/images//xs/avatar4.svg';
import Avatar5 from '../../../assets/images//xs/avatar5.svg';
import Avatar3 from '../../../assets/images//xs/avatar3.svg';


export const ContactData=[
    {
        image:Avatar1,
        name:'Hannah Gill',
        message:'hannahgill@eBazar.com'
    },
    {
        image:Avatar1,
        name:'Abigail Bell',
        message:'abigailbell@eBazar.com'
    },
    {
        image:Avatar3,
        name:'Megan Dyer',
        message:'barbara.kelly@eBazar.com'
    },
    {
        image:Avatar4,
        name:'Ruth Cornish',
        message:'ruthcornish@eBazar.com'
    },
    {
        image:Avatar5,
        name:'Yvonne Duncan',
        message:'yvonneduncan@eBazar.com'
    },
    {
        image:Avatar6,
        name:'Nicola Carl',
        message:'nicolacarl@eBazar.com'
    },
]